module.exports = __webpack_public_path__ + "img/4cf48f6.png";